/* Nano Clear v2 (ncx) interactions. Source: ncx-src/ncx.js, copied to assets/ncx.js by build.py.
   Each component is found by a data-nx-* attribute and set up again when the theme editor reloads a section. */
(function () {
  'use strict';
  var d = document, R = d.documentElement, C = window.NCX || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || d).querySelectorAll(s)); };
  if (C.design) R.classList.add('nx-design-mode');

  /* ---------- helpers ---------- */
  function money(cents) {
    var f = C.money || '${{amount}}', v = (cents || 0) / 100;
    var fix = function (n, dp, ts, ds) {
      var p = n.toFixed(dp).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fix(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fix(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fix(v, 0, '.', ',');
      var s = fix(v, 2, ',', '.');
      return C.trimZeros !== false ? s.replace(/\.00$/, '') : s;
    });
  }
  C.formatMoney = money;
  function toast(msg) {
    var t = $('#nx-toast');
    if (!t) { t = d.createElement('div'); t.id = 'nx-toast'; t.className = 'nx-toast'; t.setAttribute('role', 'status'); var w = d.createElement('div'); w.className = 'nx'; w.appendChild(t); d.body.appendChild(w); }
    t.textContent = msg; t.classList.add('on'); clearTimeout(toast.k);
    toast.k = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  C.toast = toast;
  function onView(el, fn, th) {
    if (!IO || C.design) { fn(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, { threshold: th || .2 });
    io.observe(el);
  }
  function tpl(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }

  /* ---------- headings and entrance animation ---------- */
  var HEADS = '.nx-title, .nx-film-copy h1, .nx-film-copy h2, .nx-tile-copy h3, .nx-panel h1, .nx-panel .nx-ptitle';
  var FX = '.nx-cats > *, .nx-products > *, .nx-bento > *, .nx-promise-grid > *, .nx-3 > *, .nx-revs > *, .nx-vrevs > *, .nx-refills > *, .nx-vs > *, .nx-vs2 > *, .nx-chaps > *, .nx-plan > *, .nx-faq > *, .nx-lead, .nx-btns, .nx-icons > *, .nx-inside > *, .nx-passes > *';
  function splitWords(hd) {
    var n = 0, walker = d.createTreeWalker(hd, NodeFilter.SHOW_TEXT), texts = [];
    while (walker.nextNode()) if (walker.currentNode.nodeValue.trim()) texts.push(walker.currentNode);
    texts.forEach(function (t) {
      var frag = d.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
        var w = d.createElement('span'); w.className = 'w';
        var s = d.createElement('span'); s.style.setProperty('--i', n++); s.textContent = p;
        w.appendChild(s); frag.appendChild(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
  }
  function anim(root) {
    $$('[data-nx-head]', root).concat(root.matches && root.matches('[data-nx-head]') ? [root] : []).forEach(function (sec) {
      var mode = sec.dataset.nxHead;
      if (mode === 'words' || mode === 'fade') {
        $$(HEADS, sec).forEach(function (hd) {
          if (hd.closest('[data-nx-head]') !== sec || hd.dataset.nxDone) return;
          hd.dataset.nxDone = 1;
          if (reduce) return;
          if (mode === 'words') { splitWords(hd); hd.classList.add('nx-rv'); } else hd.classList.add('nx-rv-fade');
          if (C.design) { hd.classList.add('in'); return; }
          onView(hd, function () { hd.classList.add('in'); });
        });
      }
      if (/nx-fx-(up|fade)/.test(sec.className)) {
        var idx = new Map();
        $$(FX, sec).forEach(function (el) {
          var p = el.parentNode, i = idx.get(p) || 0; idx.set(p, i + 1);
          el.classList.add('nx-fx'); el.style.setProperty('--fx-i', i);
        });
        onView(sec, function () { sec.classList.add('in'); }, .12);
      }
    });
  }

  /* ---------- video ---------- */
  var vio = IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && !reduce && !v.nxUserPaused && v.dataset.nxOn !== '0') { v.play().catch(function () {}); }
      else v.pause();
    });
  }, { threshold: .3 }) : null;
  /* posters of videos further down load when they come near the screen */
  var pio = IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target; pio.unobserve(t);
      (t.tagName === 'VIDEO' ? [t] : $$('video[data-poster]', t)).forEach(function (v) { if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); } });
    });
  }, { rootMargin: '800px 0px 800px 0px' }) : null;
  function race(root) { $$('[data-nx-race]', root).forEach(function (r) { if (C.design) { r.classList.add('go'); return; } onView(r, function () { r.classList.add('go'); }, .3); }); }
  function videos(root) {
    $$('video[data-poster]', root).forEach(function (v) {
      if (!pio) { v.poster = v.dataset.poster; return; }
      pio.observe(v.closest('.nx-reel, .nx-vrevs, .nx-gal, .nx-film') || v);
    });
    $$('video[data-nx-auto]', root).forEach(function (v) {
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      if (vio) vio.observe(v);
    });
    $$('[data-nx-vctl]', root).forEach(function (b) {
      var box = b.parentNode;
      var vid = function () { return $('video.on', box) || $('video', box); };
      var sync = function () { var v = vid(); if (!v) return; b.classList.toggle('paused', v.paused); b.setAttribute('aria-label', v.paused ? (b.dataset.play || 'Play video') : (b.dataset.pause || 'Pause video')); };
      $$('video', box).forEach(function (v) { v.addEventListener('play', sync); v.addEventListener('pause', sync); });
      b.addEventListener('click', function () { var v = vid(); if (!v) return; if (v.paused) { v.nxUserPaused = false; v.play().catch(function () {}); } else { v.nxUserPaused = true; v.pause(); } });
      sync();
    });
  }

  /* ---------- film / slideshow hero ---------- */
  function film(root) {
    $$('[data-nx-film]', root).forEach(function (f) {
      var slides = $$('.nx-film-slide', f), i = 0, ms = +f.dataset.interval || 0, t, ctl = $('.nx-film-ctrl', f);
      function go(n) { slides.forEach(function (s, k) { s.classList.toggle('on', k === n); var v = $('video', s); if (v) { if (k === n && !reduce) v.play().catch(function () {}); else v.pause(); } }); i = n; }
      function run() { clearInterval(t); if (ms && slides.length > 1 && !reduce) t = setInterval(function () { go((i + 1) % slides.length); }, ms); }
      run();
      if (ctl && !ctl.hasAttribute('data-nx-vctl')) ctl.addEventListener('click', function () {
        var v = $('.nx-film-slide.on video', f), paused = ctl.classList.toggle('paused');
        if (paused) { clearInterval(t); if (v) { v.nxUserPaused = true; v.pause(); } } else { run(); if (v) { v.nxUserPaused = false; v.play().catch(function () {}); } }
      });
    });
  }

  /* ---------- header: announcement, mega menu, drawer ---------- */
  function header(root) {
    $$('[data-nx-rotate]', root).forEach(function (bar) {
      var items = $$('.nx-announce__item', bar), i = 0, ms = +bar.dataset.nxRotate || 4000;
      if (items.length < 2 || reduce) return;
      setInterval(function () { items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }, ms);
    });
    $$('[data-nx-header]', root).forEach(function (h) {
      var trig = $('[data-nx-mega-trigger]', h), mega = $('[data-nx-mega]', h);
      function close() { if (trig && mega) { trig.setAttribute('aria-expanded', 'false'); mega.hidden = true; } }
      function open() { if (trig && mega) { trig.setAttribute('aria-expanded', 'true'); mega.hidden = false; } }
      if (trig && mega) {
        trig.addEventListener('click', function () { trig.getAttribute('aria-expanded') === 'true' ? close() : open(); });
        if (h.dataset.hover === 'true' && matchMedia('(hover:hover)').matches) {
          var k; var enter = function () { clearTimeout(k); open(); }, leave = function () { k = setTimeout(close, 180); };
          trig.addEventListener('mouseenter', enter); mega.addEventListener('mouseenter', enter);
          trig.addEventListener('mouseleave', leave); mega.addEventListener('mouseleave', leave);
        }
        mega.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
        d.addEventListener('click', function (e) { if (!e.target.closest('[data-nx-header]')) close(); });
        d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
        h.nxOpenMega = open; h.nxCloseMega = close;
      }
      var dr = $('[data-nx-drawer]', h.parentNode) || $('[data-nx-drawer]');
      var shut = function () { if (dr) { dr.hidden = true; d.body.style.overflow = ''; } };
      $$('[data-nx-drawer-open]', h).forEach(function (b) { b.addEventListener('click', function () { if (dr) { dr.hidden = false; d.body.style.overflow = 'hidden'; } }); });
      if (dr) {
        $$('[data-nx-drawer-close]', dr).forEach(function (b) { b.addEventListener('click', shut); });
        dr.addEventListener('click', function (e) { if (e.target.closest('a')) shut(); });
        d.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
      }
    });
  }

  /* ---------- cart ---------- */
  var Cart = {
    bag: function () { return $('[data-nx-bag]'); },
    open: function () { var b = Cart.bag(); if (!b) { location.href = C.cartUrl || '/cart'; return; } b.classList.add('open'); b.setAttribute('aria-hidden', 'false'); var s = $('[data-nx-scrim]'); if (s) s.classList.add('on'); },
    close: function () { var b = Cart.bag(); if (!b) return; b.classList.remove('open'); b.setAttribute('aria-hidden', 'true'); var s = $('[data-nx-scrim]'); if (s) s.classList.remove('on'); },
    fetch: function () { return fetch((C.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); return c; }); },
    change: function (key, q) {
      return fetch((C.root || '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); });
    },
    add: function (items, btn) {
      if (!items.length) return Promise.resolve();
      if (btn) btn.classList.add('is-loading');
      return fetch(C.cartAdd ? C.cartAdd + '.js' : '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return Cart.fetch(); })
        .then(function () {
          var b = Cart.bag();
          if (b && b.dataset.after === 'toast') toast(b.dataset.added || 'Added to your cart');
          else setTimeout(Cart.open, reduce ? 0 : 200);
          d.dispatchEvent(new CustomEvent('nx:cart:added', { detail: { items: items } }));
        })
        .catch(function (e) { toast((e && (e.description || e.message)) || 'Something went wrong. Please try again.'); })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    },
    render: function (c) {
      $$('[data-nx-count]').forEach(function (n) { n.textContent = c.item_count; n.dataset.count = c.item_count; });
      var b = Cart.bag(); if (!b) return;
      var ul = $('[data-nx-bag-list]', b), tot = $('[data-nx-bag-total]', b);
      ul.innerHTML = '';
      if (!c.items.length) { var e = d.createElement('li'); e.className = 'nx-bag-empty'; e.textContent = b.dataset.empty || 'Your cart is empty.'; ul.appendChild(e); }
      c.items.forEach(function (it) {
        var li = d.createElement('li'); li.className = 'nx-bag-i';
        li.innerHTML = '<img alt=""><div><b></b><small></small><span class="nx-qty"><button type="button">−</button><span></span><button type="button">+</button></span></div><span class="pr"></span>';
        if (it.image) li.querySelector('img').src = it.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2');
        li.querySelector('b').textContent = it.product_title;
        var sub = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        if (it.properties) Object.keys(it.properties).forEach(function (k) { if (k.charAt(0) !== '_' && it.properties[k]) sub += (sub ? ' · ' : '') + k + ': ' + it.properties[k]; });
        li.querySelector('small').textContent = sub;
        li.querySelector('.nx-qty span').textContent = it.quantity;
        var pr = li.querySelector('.pr');
        pr.innerHTML = (it.original_line_price > it.final_line_price ? '<s></s>' : '') + '<span></span>';
        if (pr.querySelector('s')) pr.querySelector('s').textContent = money(it.original_line_price);
        pr.querySelector('span').textContent = it.final_line_price ? money(it.final_line_price) : (b.dataset.free || 'Free');
        var bt = li.querySelectorAll('.nx-qty button');
        bt[0].setAttribute('aria-label', b.dataset.minus || 'Remove one'); bt[1].setAttribute('aria-label', b.dataset.plus || 'Add one');
        bt[0].onclick = function () { Cart.change(it.key, it.quantity - 1); };
        bt[1].onclick = function () { Cart.change(it.key, it.quantity + 1); };
        ul.appendChild(li);
      });
      if (tot) tot.textContent = money(c.total_price);
    }
  };
  C.cart = Cart;
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-nx-cart-open]');
    if (o && Cart.bag()) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-nx-bag-close], [data-nx-scrim]')) Cart.close();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

  /* ---------- add to cart (cards, buy boxes, bars, receipts) ---------- */
  function formOf(btn) { return (btn.dataset.form && d.getElementById(btn.dataset.form)) || btn.closest('[data-nx-form]'); }
  function collect(form, btn) {
    var items = [], props = {};
    var v = btn.dataset.variant || '';
    var qty = +(btn.dataset.qty || 1);
    if (form) {
      var vr = $('[name="nx-variant"]:checked', form) || $('select[name="nx-variant"]', form);
      v = (vr && vr.value) || form.dataset.variant || v;
      var opt = $('[name="nx-opt"]:checked', form);
      if (opt) { qty = +(opt.dataset.qty || 1); if (opt.dataset.variant) v = opt.dataset.variant; if (opt.dataset.prop) props[opt.dataset.prop] = opt.dataset.propval || opt.dataset.label || 'Yes'; }
      $$('[data-nx-addon]:checked', form).forEach(function (a) {
        if (a.dataset.variant) items.push({ id: +a.dataset.variant, quantity: +(a.dataset.qty || 1) });
        else if (a.dataset.prop) props[a.dataset.prop] = a.dataset.propval || 'Yes';
      });
    }
    if (v) items.unshift({ id: +v, quantity: qty, properties: props });
    return items;
  }
  d.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nx-add]');
    if (!btn) return;
    e.preventDefault();
    var items = collect(formOf(btn), btn);
    if (!items.length) { if (btn.href && btn.getAttribute('href') !== '#') location.href = btn.href; return; }
    Cart.add(items, btn);
  });

  function buy(root) {
    $$('[data-nx-form]', root).forEach(function (f) {
      var sec = f.hasAttribute('data-nx-scope') ? f : (f.closest('.shopify-section') || d);
      var fid = f.getAttribute('id'); // a form's .id can be its <input name="id">
      var outs = function () { return $$('[data-nx-price-out]', sec).concat(fid ? $$('[data-form="' + fid + '"] [data-nx-price-out], [data-nx-bar-for="' + fid + '"] [data-nx-price-out]') : []); };
      function sync() {
        var opt = $('[name="nx-opt"]:checked', f), vr = $('[name="nx-variant"]:checked', f) || $('select[name="nx-variant"]', f);
        var vo = vr && (vr.tagName === 'SELECT' ? vr.options[vr.selectedIndex] : vr);
        var price = null, text = null;
        if (vo && vo.dataset.price) price = +vo.dataset.price;
        if (price == null && f.dataset.price) price = +f.dataset.price;
        $$('[name="nx-opt"]', f).forEach(function (o) { var sp = o.closest('label') && $('[data-nx-opt-price]', o.closest('label')); if (sp && price != null) sp.textContent = money(price * (+o.dataset.qty || 1)); });
        if (opt) { if (opt.dataset.text) text = opt.dataset.text; else if (price != null) price = price * (+opt.dataset.qty || 1); }
        var add = 0; $$('[data-nx-addon]:checked', f).forEach(function (a) { add += +(a.dataset.price || 0); });
        if (text == null && price != null) text = money(price + add);
        if (text != null) outs().forEach(function (o) { o.textContent = text; });
        if (opt && opt.dataset.title) $$('[data-nx-opt-out]', d).forEach(function (o) { o.textContent = opt.dataset.title; });
        if (f.hasAttribute('data-nx-native')) {
          var hid = f.querySelector('input[name="id"]'), hq = f.querySelector('input[name="quantity"]');
          if (hid && vo && vo.value) hid.value = vo.value;
          if (opt && opt.dataset.variant && hid) hid.value = opt.dataset.variant;
          if (hq) hq.value = opt ? (+opt.dataset.qty || 1) : 1;
        }
        var btns = $$('[data-nx-add]', sec).concat(fid ? $$('button[name="add"][form="' + fid + '"], #' + fid + ' button[name="add"]') : []);
        btns.forEach(function (b) { b.disabled = !!(vo && vo.dataset.available === 'false'); });
        if (vo) { var th = (vo.dataset.media && $('[data-nx-thumb][data-media="' + vo.dataset.media + '"]', sec)) || (vo.dataset.vtitle && $('[data-nx-thumb][data-vtitle="' + vo.dataset.vtitle + '"]', sec)); if (th && th.getAttribute('aria-current') !== 'true' && f.nxReady) th.click(); }
        receipt(f);
      }
      f.addEventListener('change', sync);
      if ($('[name="nx-opt"], [name="nx-variant"], [data-nx-addon]', f)) sync();
      f.nxReady = true;
    });
    // gallery
    $$('[data-nx-gallery]', root).forEach(function (g) {
      var stage = $('.nx-stage', g), slides = $$('[data-nx-slide]', g), th = $$('[data-nx-thumb]', g);
      th.forEach(function (t, k) {
        t.addEventListener('click', function () {
          slides.forEach(function (s, j) {
            s.classList.toggle('on', j === k);
            if (s.tagName === 'VIDEO') { if (j === k && !reduce) { s.dataset.nxOn = '1'; s.play().catch(function () {}); } else { s.dataset.nxOn = '0'; s.pause(); } }
          });
          stage.classList.toggle('img', slides[k] && slides[k].tagName !== 'VIDEO');
          th.forEach(function (x, j) { x.setAttribute('aria-current', j === k ? 'true' : 'false'); });
        });
      });
      slides.forEach(function (s) { if (s.tagName === 'VIDEO' && !s.classList.contains('on')) s.dataset.nxOn = '0'; });
      if (slides[0] && slides[0].tagName !== 'VIDEO') stage.classList.add('img');
    });
    // sticky bars
    $$('[data-nx-bar]', root).forEach(function (bar) {
      var t = d.getElementById(bar.dataset.nxBar); if (!t || !IO) return;
      new IntersectionObserver(function (es) { var e = es[0]; bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(t);
    });
  }
  function receipt(f) {
    var r = f.matches('[data-nx-rcpt]') ? f : $('[data-nx-rcpt]', f); if (!r) return;
    var base = +r.dataset.total || 0, list = +r.dataset.list || 0, add = 0;
    $$('[data-nx-addon]', f).forEach(function (a) {
      var row = $('[data-nx-row="' + a.id + '"]', r);
      if (row) row.hidden = !a.checked;
      if (a.checked) add += +(a.dataset.price || 0);
    });
    $$('[data-nx-rtotal]', f.closest('.shopify-section') || d).forEach(function (o) { o.textContent = money(base + add); });
    $$('[data-nx-rlist]', r).forEach(function (o) { o.textContent = money(list + add); });
  }

  /* ---------- steppers (hotspots, how it works) ---------- */
  function stepper(root) {
    $$('[data-nx-stepper]', root).forEach(function (s) {
      var items = $$('[data-nx-step]', s), panes = $$('[data-nx-pane]', s), cur = 0, t, ms = +s.dataset.interval || 0;
      function go(i) {
        cur = i;
        items.forEach(function (x) { var on = +x.dataset.nxStep === i; x.classList.toggle('on', on); if (x.hasAttribute('aria-pressed')) x.setAttribute('aria-pressed', on); });
        panes.forEach(function (p) { p.classList.toggle('on', +p.dataset.nxPane === i); });
      }
      var n = 0; items.forEach(function (x) { n = Math.max(n, +x.dataset.nxStep + 1); });
      items.forEach(function (x) { x.addEventListener('click', function () { clearInterval(t); go(+x.dataset.nxStep); }); });
      s.nxGo = function (i) { clearInterval(t); go(i); };
      go(0);
      if (ms && n > 1 && !reduce && !C.design) onView(s, function () { t = setInterval(function () { go((cur + 1) % n); }, ms); }, .4);
    });
  }

  /* ---------- tabs filter, chips ---------- */
  function tabs(root) {
    $$('[data-nx-tabs]', root).forEach(function (box) {
      var sec = box.closest('.shopify-section') || d, ts = $$('[data-f]', box), items = $$('[data-c]', sec);
      ts.forEach(function (t) {
        t.addEventListener('click', function () {
          ts.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
          var f = t.dataset.f;
          items.forEach(function (p) { p.hidden = !(f === 'all' || (' ' + p.dataset.c + ' ').indexOf(' ' + f + ' ') > -1); });
        });
      });
    });
  }

  /* ---------- scrollers ---------- */
  function scrollers(root) {
    $$('[data-nx-scroll]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = b.closest('.shopify-section') || d, tr = $(b.dataset.target || '.nx-reel, .nx-products, .nx-vrevs', sec);
        if (tr) tr.scrollBy({ left: +b.dataset.nxScroll * tr.clientWidth * .7, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- chapters ---------- */
  function chapters(root) {
    $$('[data-nx-chapters]', root).forEach(function (s) {
      var mv = $('video', s), chs = $$('.nx-chap', s); if (!mv) return;
      mv.addEventListener('timeupdate', function () {
        var t = mv.currentTime;
        chs.forEach(function (c) { var a = +c.dataset.t, z = +c.dataset.e, on = t >= a && t < z; c.classList.toggle('on', on); c.classList.toggle('done', t >= z); var i = $('.bar i', c); if (i) i.style.width = on ? ((t - a) / (z - a) * 100) + '%' : (t >= z ? '100%' : '0'); });
      });
      chs.forEach(function (c) { c.addEventListener('click', function () { mv.currentTime = +c.dataset.t + .01; mv.nxUserPaused = false; mv.play().catch(function () {}); }); });
    });
  }

  /* ---------- video cards and lightbox ---------- */
  var lb;
  function lightbox() {
    if (lb) return lb;
    var w = d.createElement('div'); w.className = 'nx';
    w.innerHTML = '<div class="nx-lb" role="dialog" aria-hidden="true"><div class="nx-lb-in"><video playsinline controls></video><img class="nx-lb-img" alt="" hidden><p></p><button class="nx-lb-x" type="button" aria-label="Close video"><svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg></button></div></div>';
    d.body.appendChild(w); lb = $('.nx-lb', w);
    var close = function () { lb.classList.remove('on'); $('video', lb).pause(); lb.setAttribute('aria-hidden', 'true'); };
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    $('.nx-lb-x', lb).addEventListener('click', close);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return lb;
  }
  d.addEventListener('click', function (e) {
    var c = e.target.closest('[data-nx-lb]'); if (!c) return;
    var v = $('video', c), img = c.dataset.img, src = c.dataset.src || (v && (v.currentSrc || v.src)); if (!src && !img) return;
    e.preventDefault();
    var box = lightbox(), lv = $('video', box), li = $('.nx-lb-img', box);
    lv.hidden = !!img; li.hidden = !img;
    if (img) { lv.pause(); li.src = img; li.alt = c.dataset.cap || ''; $('p', box).textContent = c.dataset.cap || ''; box.classList.add('on'); box.setAttribute('aria-hidden', 'false'); return; }
    lv.src = src; lv.poster = (v && v.poster) || ''; lv.muted = c.dataset.sound !== 'true';
    $('p', box).textContent = c.dataset.cap || '';
    box.classList.add('on'); box.setAttribute('aria-hidden', 'false'); lv.play().catch(function () {});
  });
  function vcards(root) {
    $$('.nx-vcard video', root).forEach(function (v) {
      var c = v.parentNode;
      v.addEventListener('play', function () { c.classList.add('playing'); });
      v.addEventListener('pause', function () { c.classList.remove('playing'); });
    });
  }

  /* ---------- club: card tilt, care plan, rewards, refills, invite ---------- */
  function club(root) {
    $$('[data-nx-tilt]', root).forEach(function (tilt) {
      var card = $('.nx-mcard', tilt); if (!card || reduce || !matchMedia('(hover:hover)').matches) return;
      var a = +tilt.dataset.nxTilt || 14;
      tilt.addEventListener('pointermove', function (e) { var r = tilt.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; card.style.transform = 'rotateY(' + (x * a) + 'deg) rotateX(' + (-y * a * .85) + 'deg)'; });
      tilt.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
    $$('[data-nx-plan]', root).forEach(plan);
    $$('[data-nx-rewards]', root).forEach(function (box) {
      var max = +box.dataset.max || 800, tiers = $$('[data-min]', box).sort(function (a, b) { return a.dataset.min - b.dataset.min; });
      var out = $('[data-nx-pts]', box), meter = $('[data-nx-meter]', box), next = $('[data-nx-next]', box);
      function pts() {
        var t = 0; $$('input[type=checkbox]:checked', box).forEach(function (x) { t += +x.value || 0; });
        var from = +out.textContent || 0, st = performance.now();
        (function tick(n) { var k = reduce ? 1 : Math.min(1, (n - st) / 500); out.textContent = Math.round(from + (t - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); })(st);
        if (meter) meter.style.width = Math.min(100, t / max * 100) + '%';
        var up = null; tiers.forEach(function (li) { var on = t >= +li.dataset.min; li.classList.toggle('on', on); if (!on && !up) up = li; });
        if (next) next.textContent = up ? tpl(box.dataset.nextText || '{n} points to {tier}', { n: +up.dataset.min - t, tier: up.dataset.name }) : tpl(box.dataset.topText || 'You reach {tier}, the top tier', { tier: tiers.length ? tiers[tiers.length - 1].dataset.name : '' });
      }
      box.addEventListener('change', pts); pts();
    });
    $$('[data-nx-remind]', root).forEach(function (b) {
      b.addEventListener('click', function () { var s = $('select', b.parentNode); toast(tpl(b.dataset.nxRemind || 'Reminder set: {v}', { v: s ? s.value.toLowerCase() : '' })); });
    });
    $$('[data-nx-copy]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = d.getElementById(b.dataset.nxCopy), v = i ? i.value : '';
        if (navigator.clipboard) navigator.clipboard.writeText(v).then(function () { toast(b.dataset.ok || 'Link copied'); }, function () { if (i) i.select(); toast(b.dataset.fail || 'Select the link to copy it'); });
        else { if (i) i.select(); toast(b.dataset.fail || 'Select the link to copy it'); }
      });
    });
  }
  var ICP = {
    r: '<svg viewBox="0 0 24 24"><path d="M12 3l1.8 4.6L18.5 9l-4.7 1.6L12 15l-1.8-4.4L5.5 9l4.7-1.4z"/></svg>',
    l: '<svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="10" rx="2.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
    t: '<svg viewBox="0 0 24 24"><path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/></svg>',
    f: '<svg viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 3.5v4h4"/></svg>'
  };
  function plan(box) {
    var cfgEl = $('script[type="application/json"]', box); if (!cfgEl) return;
    var C2 = JSON.parse(cfgEl.textContent), f = $('form', box), loc = C2.locale || undefined;
    function run() {
      var wear = $('[name="wear"]:checked', f), metal = $('[name="metal"]:checked', f), life = $$('[name="life"]:checked', f).map(function (x) { return x.value; });
      if (!wear || !metal) return;
      var wk = +wear.dataset.weeks || 4;
      if (life.indexOf('active') > -1) wk = Math.max(C2.minWeeks || 3, wk - (C2.activeLess || 1));
      var lock = life.indexOf('city') > -1 ? (C2.lockCity || 1) : (C2.lockOther || 3);
      var refillWk = wk * (C2.uses || 12), now = new Date();
      var nx = new Date(now.getTime() + wk * 7 * 864e5), rf = new Date(now.getTime() + refillWk * 7 * 864e5);
      var fmt = function (x) { return x.toLocaleDateString(loc, { month: 'short', day: 'numeric' }); };
      $('[data-nx-plan-title]', box).textContent = tpl(C2.title, { metal: metal.dataset.label, wear: wear.dataset.phrase });
      var rows = [
        [ICP.r, C2.r1, tpl(C2.r1s, { weeks: wk, date: fmt(nx) }), tpl(C2.perYear, { n: Math.round(52 / wk) })],
        [ICP.l, C2.r2, lock === 1 ? C2.r2city : tpl(C2.r2other, { months: lock }), tpl(C2.perYear, { n: Math.round(12 / lock) })],
        [ICP.f, C2.r3, tpl(C2.r3s, { date: rf.toLocaleDateString(loc, { month: 'long', year: 'numeric' }) }), refillWk > 52 ? tpl(C2.everyMonths, { n: Math.round(refillWk / 4.33) }) : tpl(C2.perYear, { n: Math.round(52 / refillWk) })]
      ];
      if (life.indexOf('travel') > -1) rows.push([ICP.t, C2.r4, C2.r4s, C2.r4b]);
      var ul = $('[data-nx-plan-list]', box); ul.innerHTML = '';
      rows.forEach(function (r, i) {
        var li = d.createElement('li'); li.style.animationDelay = (i * 60) + 'ms';
        li.innerHTML = r[0] + '<span><span class="h"></span><small></small></span><b></b>';
        $('.h', li).textContent = r[1]; $('small', li).textContent = r[2]; $('b', li).textContent = r[3]; ul.appendChild(li);
      });
      var y = $('[data-nx-year]', box); y.innerHTML = '';
      for (var m = 0; m < 12; m++) {
        var dt = new Date(now.getFullYear(), now.getMonth() + m, 1), col = d.createElement('div'), c = d.createElement('span'); c.className = 'col';
        var w0 = m * 52 / 12, w1 = (m + 1) * 52 / 12, n = Math.floor(w1 / wk) - Math.floor(w0 / wk), k, i1;
        for (k = 0; k < n; k++) { i1 = d.createElement('i'); i1.className = 'nx-k1'; i1.style.animationDelay = (m * 30) + 'ms'; c.appendChild(i1); }
        if (m % lock === 0) { i1 = d.createElement('i'); i1.className = 'nx-k2'; i1.style.animationDelay = (m * 30) + 'ms'; c.appendChild(i1); }
        if (Math.floor(w1 / refillWk) > Math.floor(w0 / refillWk)) { i1 = d.createElement('i'); i1.className = 'nx-k3'; c.appendChild(i1); }
        col.appendChild(c); col.appendChild(d.createTextNode(dt.toLocaleDateString(loc, { month: 'short' }))); y.appendChild(col);
      }
    }
    f.addEventListener('change', run); f.addEventListener('submit', function (e) { e.preventDefault(); }); run();
  }

  /* ---------- delivery date ---------- */
  function delivery(root) {
    $$('[data-nx-delivery]', root).forEach(function (el) {
      var skip = el.dataset.skip === 'true';
      function add(n) { var d0 = new Date(), k = 0; while (k < n) { d0.setDate(d0.getDate() + 1); if (!skip || (d0.getDay() !== 0 && d0.getDay() !== 6)) k++; } return d0; }
      function fmt(x) { var day = x.getDate(), suf = (day % 10 === 1 && day !== 11) ? 'st' : (day % 10 === 2 && day !== 12) ? 'nd' : (day % 10 === 3 && day !== 13) ? 'rd' : 'th'; return x.toLocaleDateString('en-US', { month: 'long' }) + ' ' + day + suf; }
      var a = add(+el.dataset.min || 0), mx = +el.dataset.max || 0, out = $('[data-nx-delivery-date]', el);
      out.textContent = fmt(a) + (mx > +el.dataset.min ? ' to ' + fmt(add(mx)) : '');
    });
  }

  /* ---------- count-up stats ---------- */
  function stats(root) {
    $$('[data-nx-countup]', root).forEach(function (box) {
      var nums = $$('[data-to]', box), ms = +box.dataset.nxCountup || 1600;
      function fmt(n, el) { var dp = +(el.dataset.dp || 0), s = n.toFixed(dp); if (el.dataset.sep !== 'false') s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return s; }
      function run() {
        nums.forEach(function (el) {
          var to = +el.dataset.to, st = performance.now();
          if (reduce || C.design || !ms) { el.textContent = fmt(to, el); return; }
          (function tick(n) { var k = Math.min(1, (n - st) / ms), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * e, el); if (k < 1) requestAnimationFrame(tick); })(st);
        });
      }
      nums.forEach(function (el) { el.textContent = fmt(0, el); });
      onView(box, run, .1);
    });
  }

  /* ---------- before / after slider ---------- */
  function ba(root) {
    $$('[data-nx-ba]', root).forEach(function (sec) {
      var stage = $('.nx-ba', sec), panes = $$('.nx-ba-pane', sec), tabs = $$('[data-ba]', sec), cap = $('.nx-ba-cap', sec);
      if (!stage) return;
      function set(p) { p = Math.max(0, Math.min(100, p)); stage.style.setProperty('--pos', p + '%'); stage.setAttribute('aria-valuenow', Math.round(p)); }
      function at(x) { var r = stage.getBoundingClientRect(); set((x - r.left) / r.width * 100); }
      var drag = false;
      stage.addEventListener('pointerdown', function (e) { drag = true; stage.setPointerCapture(e.pointerId); at(e.clientX); });
      stage.addEventListener('pointermove', function (e) { if (drag) at(e.clientX); });
      stage.addEventListener('pointerup', function () { drag = false; });
      stage.addEventListener('pointercancel', function () { drag = false; });
      stage.addEventListener('keydown', function (e) { var p = parseFloat(getComputedStyle(stage).getPropertyValue('--pos')) || 50; if (e.key === 'ArrowLeft') { set(p - 5); e.preventDefault(); } if (e.key === 'ArrowRight') { set(p + 5); e.preventDefault(); } });
      tabs.forEach(function (t) { t.addEventListener('click', function () {
        var i = +t.dataset.ba; panes.forEach(function (p, k) { p.classList.toggle('on', k === i); });
        tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        if (cap) cap.textContent = t.dataset.cap || ''; set(+sec.dataset.start || 50);
      }); });
      set(+sec.dataset.start || 50);
      if (sec.dataset.intro === 'true' && !reduce && !C.design) onView(stage, function () {
        var st = performance.now(), from = +sec.dataset.start || 50;
        (function tick(n) { var k = Math.min(1, (n - st) / 1800); set(from + Math.sin(k * Math.PI * 2) * 18); if (k < 1) requestAnimationFrame(tick); else set(from); })(st);
      }, .5);
    });
  }

  /* ---------- accordions ---------- */
  function acc(root) {
    $$('[data-nx-acc-single]', root).forEach(function (box) {
      var all = $$('details', box);
      all.forEach(function (x) { x.addEventListener('toggle', function () { if (x.open) all.forEach(function (y) { if (y !== x) y.open = false; }); }); });
    });
  }

  /* ---------- boot ---------- */
  function init(root) {
    root = root || d;
    [anim, race, videos, film, header, buy, stepper, tabs, scrollers, chapters, vcards, club, acc, stats, ba, delivery].forEach(function (fn) { try { fn(root); } catch (e) { if (window.console) console.warn('ncx', fn.name, e); } });
  }
  function boot() { init(d); if (Cart.bag() || $('[data-nx-count]')) Cart.fetch().catch(function () {}); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var b = e.target, s = b.closest('[data-nx-stepper]');
    if (s && s.nxGo) { var st = b.matches('[data-nx-step]') ? b : $('[data-nx-step]', b); if (st) s.nxGo(+st.dataset.nxStep); }
    var h = b.closest('[data-nx-header]'); if (h && b.closest('[data-nx-mega]') && h.nxOpenMega) h.nxOpenMega();
    var t = b.matches('[data-f]') ? b : null; if (t) t.click();
  });
  d.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('[data-nx-bag]') && e.detail && e.detail.load === false) {} });
})();
